module.exports = __webpack_public_path__ + "img/case21.c37fdc81.png";